import { render, staticRenderFns } from "./JournalSectionsTree.vue?vue&type=template&id=c57f868e&scoped=true&"
import script from "./JournalSectionsTree.vue?vue&type=script&lang=js&"
export * from "./JournalSectionsTree.vue?vue&type=script&lang=js&"
import style0 from "./JournalSectionsTree.vue?vue&type=style&index=0&id=c57f868e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57f868e",
  null
  
)

export default component.exports